import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';
import { CancelToken } from 'axios';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});
const SuspendAndRecoverAccount = props => {
    let { classes, accountModalState, activeCustomer, translations, handleOpen, onRecover, onSuspend } = props;

    const recoverCancel = CancelToken?.source();
    const suspendCancel = CancelToken?.source();

    const handleCloseSafe = () => {
        handleOpen();
    }

    const handleCloseDanger = async () => {
        if (accountModalState.recover) {
            await onRecover({ AccountID: accountModalState.AccountID, ActiveCustomerID: activeCustomer }, { cancelToken: recoverCancel });
            handleOpen();
            return;
        }
        await onSuspend({ AccountID: accountModalState.AccountID, ActiveCustomerID: activeCustomer }, { cancelToken: suspendCancel });
        handleOpen();
    };
    useEffect(() => {
        return () => {
            recoverCancel.cancel('Operation canceled by the user.');
            suspendCancel.cancel('Operation canceled by the user.');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog
            open={accountModalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{accountModalState.recover ? translations['recover'] || 'Recover' : translations['suspend'] || 'Suspend'} {translations['account'] || "account"}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['be_carefully_when'] || "Be carefully when"} {accountModalState.recover ? translations['recover'] || 'Recover' : translations['suspend'] || 'Suspend'}  {translations['something'] || "something"}.<br />
                    {translations['sure_you_want_to'] || 'Are you sure you want to '}{accountModalState.recover ? translations['recover'] || 'Recover' : translations['suspend'] || 'Suspend'}  {translations['this_account_data'] || "this account data"}?
          </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseDanger} variant="contained" className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(SuspendAndRecoverAccount);